/*eslint-disable*/
import React from 'react'
import { Link } from 'react-router-dom'

// components

import PagesDropdown from 'components/Dropdowns/PagesDropdown.js'

export default function Navbar(props) {
    const [navbarOpen, setNavbarOpen] = React.useState(false)
    return (
        <>
            <nav className="top-0 absolute z-50 w-full flex flex-wrap items-center justify-between px-2 py-3 navbar-expand-lg"></nav>
        </>
    )
}
